import type { AlternativePrice, Price, Shipping } from 'src/types';

export enum PriceDisplayEnum {
  PRICE = 'price-excludes-shipping',
  PRICE_INCLUDES_SHIPPING = 'price_includes_shipping',
}

export type PriceDisplay =
  | PriceDisplayEnum.PRICE
  | PriceDisplayEnum.PRICE_INCLUDES_SHIPPING;

export enum SortOptionEnum {
  PRICE = 'price',
  PRICEANDSTOCKSTATUS = 'price_in_stock',
}

export type SortOption =
  | SortOptionEnum.PRICE
  | SortOptionEnum.PRICEANDSTOCKSTATUS;

// Note: Copy any changes here to config/markets/types.ts
export enum FilterType {
  PRICES_INC_SHIPPING = 'prices_inc_shipping',
  IN_STOCK = 'in_stock',
  FEATURED_SHOP = 'featured_shop',
  AUTHORIZED_DEALER = 'authorized_dealer',
  PICKUP_ONLY = 'pickup_only',
  INTERNATIONAL = 'international',
  NOT_FOR_SALE = 'not_for_sale',
  VARIANT_SIZE = 'variant_size',
  VARIANT_COLOR = 'variant_color',
  CONDITION = 'condition',
  DELIVERY_METHOD = 'shipping-delivery-method',
  CARRIERS = 'shipping-carriers',
}

export type SortType =
  | SortTypeEnum.LOWEST_PRICE
  | SortTypeEnum.FASTEST_DELIVERY;

export enum SortTypeEnum {
  LOWEST_PRICE = 'lowest-price',
  FASTEST_DELIVERY = 'fastest-delivery',
}

export enum FilterUIPlacementEnum {
  PRODUCT_HEADER,
  FILTER_MENU,
  OFFERLIST_HEADER,
}

export enum FilterUISubPlacementEnum {
  SHOW_ONLY,
  ADDITIVE,
}

export type FilterUISubPlacement =
  | FilterUISubPlacementEnum.SHOW_ONLY
  | FilterUISubPlacementEnum.ADDITIVE;

export type FilterUIPlacement =
  | FilterUIPlacementEnum.PRODUCT_HEADER
  | FilterUIPlacementEnum.FILTER_MENU
  | FilterUIPlacementEnum.OFFERLIST_HEADER;

export type FilterOffer = Price | AlternativePrice | null | undefined;

export type FilterSelection = string[];

export interface IFilter {
  active: boolean;
  label: string;
  type: FilterType;
  placement: FilterUIPlacement;
  subPlacement?: FilterUISubPlacement;
  filterFn: (offer: FilterOffer, selection?: FilterSelection) => boolean;
  filterShippingFn?: (
    shipping: Shipping,
    selection?: FilterSelection
  ) => boolean;
  filterAlternativeOffers: boolean;
  selection?: FilterSelection;
  initialSelection?: FilterSelection;
  missingInfoFn?: (offer: FilterOffer) => boolean; // Provide to keep offers with missing info
  additive?: boolean;
  treatUnfeaturedAsMissingInfo?: boolean;
  hidden?: boolean;
}

export enum SustainabilityEnum {
  SUSTAINABILITY_UNKNOWN = 'SUSTAINABILITY_UNKNOWN',
  NOT_SUSTAINABLE = 'NOT_SUSTAINABLE',
  SUSTAINABLE = 'SUSTAINABLE',
}

export enum EligibilityEnum {
  ELIGIBILITY_UNKNOWN = 'ELIGIBILITY_UNKNOWN',
  ALL = 'ALL',
  MEMBERS = 'MEMBERS',
}
